export default {
    data() {
        return {
            debouncedWidth: 0,
            widthTimeout: null,
        };
    },
    computed: {
        windowWidth: {
            get() {
                return this.debouncedWidth;
            },
            set(val) {
                if (this.timeout) clearTimeout(this.timeout);
                this.widthTimeout = setTimeout(() => {
                    this.debouncedWidth = val;
                }, 1000);
            }
        },
    },
    methods: {
        resizeHandler() {
            this.windowWidth = window.innerWidth;
        },
    },
    mounted() {
        this.debouncedWidth = window.innerWidth;
    },
    created() {
        window.addEventListener("resize", this.resizeHandler);
    },
    destroyed() {
        window.removeEventListener("resize", this.resizeHandler);
    },
};
